import React, { useEffect, useState, useRef } from "react";
import { Row, Alert } from "react-bootstrap";
import ColRealTimeText from "./col_real_time_text.jsx";
import MicButton from "./mic_button.jsx";
import ColDropdown from "./col_dropdown_translate.jsx";
import ColMessage from "./col_message.jsx";
import ColTranslate from "./col_translate.jsx";
import ColSummarize from "./col_summarize.jsx";
import { baseUrl_api } from './url.jsx';
import { CSSTransition } from "react-transition-group";
import './speech.css';

function Speech ({ loginInfo, isMobile, onCheckLogin }) {
  // 将您的状态和处理函数移动到这里
  const [recognizedText, setRecognizedText] = useState('');
  const [speaker, setSpeaker] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const [isShow, setIsShow] = useState(false);
  // const [translateLanguage, setTranslateLanguage] = useState('');
  const [translateLanguageValue, setTranslateLanguageValue] = useState('');
  const [translateLanguage, setTranslateLanguage] = useState('');
  const [realTimeText, setRealTimeText] = useState('');
  const [conversations, setConversations] = useState([]);
  const [timeStamp, setTimeStamp] = useState('');
  const [showAlert, setShowAlert] = useState(false);  // 控制显示 Alert
  const [statusAlert, setStatusAlert] = useState(''); // Alert 状态
  const [message, setMessage] = useState(''); 
  const alertRef = useRef(null);
  const [speechLanguage, setSpeechLanguage] = useState('Chinese');
  const [isPro, setIsPro] = useState(false);    // 标记是否付费用户
  const [saveSpeech, setSaveSpeech] = useState(false);
  const [saveTranslation, setSaveTranslation] = useState(false);



  const handleRecordingStatusChange = (recording) => {
    setIsRecording(recording);
  };

  const handleRerealTimeTextChange = (text) => {
    setRealTimeText(text);
  };


  useEffect(() => {
    if(message) {      
      setShowAlert(true);
    }
  }, [statusAlert]);

  useEffect(() => {
    if (showAlert === true) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 6000);

      return () => {
        clearTimeout(timer);
      };
    };    
  }, [showAlert]);


  useEffect(() => {
    if (loginInfo.islogin) {
      const uid = loginInfo.uid;
      
      // 获取当日时间剩余
      fetch(baseUrl_api + "/meeting_left", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid: uid }),
        keepalive: true,
      })
      .then(response => response.json())
      .then(data => {
        const json_data = JSON.parse(data.response);
        const minutes = json_data.minutes;
        const total = json_data.total;

        // 设置 Alter 状态
        if (minutes <= 0) {
          setStatusAlert("danger");
        } else if (minutes <= 10) {
          setStatusAlert("warning");
        } else {          
          setStatusAlert("success");
        }

        if (total > 10) {
          setIsPro(true);     // 标记为付费用户
        }
        
        if (total < 1440){          
          setMessage(`您今日剩余 ${ minutes } 分钟`);
        } else {
          setMessage(`您今日使用不限时间`);
        }
      })
      .catch(error => {
          console.error(error);
      });
    };
  }, [loginInfo])
  

  const handleSelect = (selectedLanguage, selectedValue) => {
    // 在这里处理选择的值，例如将其传递给其他组件或执行其他操作
    // setTranslateLanguage(selectedLanguage); // 更新 selectedValue
    setTranslateLanguageValue(selectedValue); // 更新 selectedValue
    setTranslateLanguage(selectedLanguage);
  };

  // 从子组件根据剩余时间传递 Alert 状态
  const handleAlertStatus = (alterStatus) => {    
    if(statusAlert !== alterStatus) {
      if (alterStatus === "warning") {
        setMessage("您今日的剩余时间已经不足 10 分钟，请注意。")
      } else if (alterStatus === "danger") {
        setMessage("您今日的时间已用尽！")
      };

      setStatusAlert(alterStatus);
    };
  };

  const handleConversations = (updatedConversations) => {
    // console.log("Conversations from child:", updatedConversations);
    // 在这里处理子组件传递的 conversations
    setConversations(updatedConversations);
  };

  useEffect(() => {
    setIsShow(isRecording || realTimeText.length > 0 )
  }, [isRecording]);

  useEffect(() => {
    const currentTime = new Date().toLocaleTimeString([], {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })

    setTimeStamp(currentTime)
  }, [recognizedText]);

  const renderAlert = () => {
    return (
      showAlert &&
        <Alert variant={`${ statusAlert }`}>
          {message}
        </Alert>
    );
  };

  // 保存对话
  const handleSaveSpeech = () => {
    setSaveSpeech(true)
  };
  // 保存翻译
  const handleSaveTranslation = () => {
    setSaveTranslation(true)
  };

  // 获取 speech 语种
  const handleSpeechLanguage = (value) => {
    console.log(value);
    setSpeechLanguage(value);
  };


  return (
    <>
      <h1 className="text-center mt-5">MEETING MATE</h1>
      <CSSTransition
        in={showAlert}
        timeout={300}
        classNames="alert-transition"
        unmountOnExit
        nodeRef={alertRef}
      >
        <div ref={alertRef}>{renderAlert()}</div>
      </CSSTransition>
      { isShow &&
        <ColRealTimeText
          realTimeText={ isShow ? realTimeText: ""}
        />
      }
      <Row className="align-items-center">
        <MicButton
          loginInfo={loginInfo}
          isMobile={isMobile}
          onRecordingStatusChange={handleRecordingStatusChange}
          onRecognizedTextChange={setRecognizedText}
          onSepaker={setSpeaker}
          onRealTimeText={handleRerealTimeTextChange}
          onAlertStatus={handleAlertStatus}
          onClickSaveSpeech={handleSaveSpeech}
          onCheckLogin={onCheckLogin}
          onSpeechLanguage={handleSpeechLanguage}
          isPro={isPro}
        />
        <ColDropdown          
          isMobile={isMobile}
          onSelect={handleSelect}
          onClick={handleSaveTranslation}
          isRecording={isRecording.current}
        />
      </Row>

      <Row className="mt-2">
        <ColMessage
          id="voiceTextarea" height= {isMobile ? "45vh" : "55vh"}  
          message={recognizedText}
          speaker={speaker}
          onConversationsUpdate={handleConversations}
          timeStamp={timeStamp}
          saveSpeech={saveSpeech}
          onSaved={() => setSaveSpeech(false)}
        />
        <ColTranslate
          id="translateTextarea" height= {isMobile ? "45vh" : "55vh"}  
          message={recognizedText}
          speaker={speaker}
          speechLanguage={speechLanguage}
          language={translateLanguageValue}
          alias={translateLanguage}
          timeStamp={timeStamp}
          saveTranslation={saveTranslation}
          onSaved={() => setSaveTranslation(false)}
        />
      </Row>

      <ColSummarize conversations={conversations} language={translateLanguageValue}/>          
    </>
  );
};

export default Speech;